import React from 'react';
import { SecondaryButton } from '../HighlightButton/HighlightButton';

const Page404 = () => {
  return (
    <div className="mainContainer centeredVertically">
      <div className="centeredHorizontallyOnMobile textCenteredOnMobile">

        <h1>Page not found</h1>
        <div style={{ paddingTop: 10 }}>
          <SecondaryButton onClick={() => window.location.href = "/"}>Return Home</SecondaryButton>
        </div>
      </div>
    </div>
  )
}

export default Page404;
